"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffset = void 0;
const getOffset = ({ currentPage, size, offset, limit }) => {
    const pageOffset = currentPage && currentPage > 1 ? (currentPage - 1) * size : offset;
    return limit ? Math.min(pageOffset, limit) : pageOffset;
};
exports.getOffset = getOffset;
//# sourceMappingURL=getOffset.js.map